import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import './home.css';

/* ---- Inline icons (no external assets) ---- */
const Icon = {
  spark: (p) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" {...p}>
      <path d="M12 3l2.2 5.3L20 10.5l-5.8 2.2L12 18l-2.2-5.3L4 10.5l5.8-2.2z" />
    </svg>
  ),
  check: (p) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...p}>
      <path d="M20 6L9 17l-5-5" />
    </svg>
  ),
  checkCircle: (p) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" {...p}>
      <circle cx="12" cy="12" r="9" /><path d="M8.5 12.5l2.4 2.4 4.6-5" />
    </svg>
  ),
  shield: (p) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" {...p}>
      <path d="M12 3l7 3v6c0 4.4-3 7.6-7 9-4-1.4-7-4.6-7-9V6z" /><path d="M9 12l2 2 4-4" />
    </svg>
  ),
  bolt: (p) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" {...p}>
      <path d="M13 2L4 14h7l-1 8 9-12h-7z" />
    </svg>
  ),
  doc: (p) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" {...p}>
      <path d="M14 3H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8z" /><path d="M14 3v5h5" /><path d="M9 13h6M9 17h6" />
    </svg>
  ),
  download: (p) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" {...p}>
      <path d="M12 3v12" /><path d="M7 10l5 5 5-5" /><path d="M5 21h14" />
    </svg>
  ),
  send: (p) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" {...p}>
      <path d="M22 2L11 13" /><path d="M22 2l-7 20-4-9-9-4z" />
    </svg>
  ),
  upload: (p) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" {...p}>
      <path d="M12 17V5" /><path d="M7 10l5-5 5 5" /><path d="M5 21h14" />
    </svg>
  ),
  plug: (p) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" {...p}>
      <path d="M9 2v6M15 2v6" /><path d="M7 8h10v3a5 5 0 0 1-10 0z" /><path d="M12 16v6" />
    </svg>
  ),
  cpu: (p) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" {...p}>
      <rect x="7" y="7" width="10" height="10" rx="2" /><path d="M10 10h4v4h-4z" />
      <path d="M9 2v3M15 2v3M9 19v3M15 19v3M2 9h3M2 15h3M19 9h3M19 15h3" />
    </svg>
  ),
  search: (p) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" {...p}>
      <circle cx="11" cy="11" r="7" /><path d="M21 21l-4-4" />
    </svg>
  ),
  code: (p) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" {...p}>
      <path d="M8 8l-4 4 4 4M16 8l4 4-4 4M13 6l-2 12" />
    </svg>
  ),
  key: (p) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" {...p}>
      <circle cx="8" cy="8" r="4" /><path d="M11 11l9 9" /><path d="M16 16l2-2M19 19l2-2" />
    </svg>
  ),
  chart: (p) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" {...p}>
      <path d="M4 20V10M10 20V4M16 20v-7M22 20H2" />
    </svg>
  ),
  building: (p) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" {...p}>
      <path d="M4 21V5a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v16" /><path d="M14 9h4a2 2 0 0 1 2 2v10" /><path d="M3 21h18M7 7h2M7 11h2M7 15h2" />
    </svg>
  ),
  users: (p) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" {...p}>
      <circle cx="9" cy="8" r="3.5" /><path d="M3 20a6 6 0 0 1 12 0" /><path d="M16 5.5a3.5 3.5 0 0 1 0 6.8M22 20a6 6 0 0 0-5-5.9" />
    </svg>
  ),
  briefcase: (p) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" {...p}>
      <rect x="3" y="7" width="18" height="13" rx="2" /><path d="M8 7V5a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2M3 12h18" />
    </svg>
  ),
  eye: (p) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" {...p}>
      <path d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7-10-7-10-7z" /><circle cx="12" cy="12" r="3" />
    </svg>
  ),
  arrow: (p) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...p}>
      <path d="M5 12h14M13 6l6 6-6 6" />
    </svg>
  ),
  minus: (p) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" {...p}>
      <path d="M5 12h14" />
    </svg>
  ),
  plus: (p) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" {...p}>
      <path d="M12 5v14M5 12h14" />
    </svg>
  ),
  alert: (p) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" {...p}>
      <path d="M12 9v4M12 17h.01" /><path d="M10.3 3.9 1.8 18a2 2 0 0 0 1.7 3h17a2 2 0 0 0 1.7-3L13.7 3.9a2 2 0 0 0-3.4 0z" />
    </svg>
  ),
  link: (p) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" {...p}>
      <path d="M10 13a5 5 0 0 0 7 0l3-3a5 5 0 0 0-7-7l-1 1" /><path d="M14 11a5 5 0 0 0-7 0l-3 3a5 5 0 0 0 7 7l1-1" />
    </svg>
  ),
  book: (p) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" {...p}>
      <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20" /><path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z" />
    </svg>
  ),
  chat: (p) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" {...p}>
      <path d="M21 15a2 2 0 0 1-2 2H8l-5 4V6a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
    </svg>
  ),
};

const VALUES = [
  { icon: Icon.shield, title: 'Catch problems before you bill', text: 'Every claim is checked up front, so issues are fixed before they ever become a denial.' },
  { icon: Icon.search, title: 'Know exactly why a claim failed', text: 'Plain-English reasons for each denial, backed by the evidence and the policy behind it.' },
  { icon: Icon.chart, title: 'Stop the same denial recurring', text: 'See what keeps going wrong with each payer and prevent it from happening again.' },
];

const OUTCOME_FILE = ['Appeal assembled from the real claim and evidence', 'Submitted straight to the payer for you', 'Run it hands-off or hold for human review'];
const OUTCOME_PACK = ['Complete, formatted, and ready to send', 'Includes the evidence and the reasoning', 'Your team stays fully in control'];

const SUITE = [
  { icon: Icon.spark,       name: 'Denial Resolve',      to: '/DenialResolve',      desc: 'Parses 835 ERA remittances and runs automated 270/271 real-time eligibility checks to route each denial to the right workflow - Correction, Appeal, or Patient Responsibility - with the reasoning shown.' },
  { icon: Icon.shield,      name: 'Claim Right',         to: '/ClaimRight',         desc: 'Scrubs 837 claims pre-submission and flags what to fix, so fewer ever come back denied.' },
  { icon: Icon.checkCircle, name: 'Medical Necessity',   to: '/MedicalNecessity',   desc: 'Confirms whether the records and LCD/NCD policy actually support the service before you appeal or bill.' },
  { icon: Icon.code,        name: 'Coding Intelligence', to: '/CodingIntelligence', desc: 'Validates NCCI/CCI edits, MUEs (Medically Unlikely Edits), and modifier usage (e.g., 25, 59) - and shows exactly how to fix them.' },
  { icon: Icon.key,         name: 'Auth & Eligibility',  to: '/AuthEligibility',    desc: 'Reconciles prior auth and 270/271 coverage against the claim before they turn into costly denials.' },
  { icon: Icon.chat,        name: 'Chat',                to: '/help/chat',          desc: 'Ask anything about denials, coding, or appeals and get instant expert guidance.' },
];

const AUDIENCES = [
  { icon: Icon.briefcase, title: 'For RCM companies', points: ['Handle more denials without adding staff', 'Keep decisions consistent across teams', 'Offer prevention and claim-quality services'] },
  { icon: Icon.building, title: 'For hospitals & health systems', points: ['Submit cleaner claims the first time', 'Recover more of the revenue you are owed', 'See what is failing and why - then fix it'] },
  { icon: Icon.users, title: 'For billing teams', points: ['Understand any denial in seconds', 'Know whether to appeal or correct', 'Skip the repetitive manual research'] },
];

const WHY = [
  { icon: Icon.shield, title: 'Trusted rules first, AI second', text: 'Decisions are grounded in real healthcare rules and your own data. AI explains and drafts - it never guesses the rules.' },
  { icon: Icon.eye, title: 'Everything is explained', text: 'Every recommendation shows the reason, the evidence found, what was missing, and the policy behind it.' },
  { icon: Icon.bolt, title: 'Built to prevent, not just react', text: 'The same intelligence that recovers denials also stops them - before the claim is ever submitted.' },
];

const LESS = ['Preventable denials', 'Manual research and rework', 'Write-offs and lost revenue', 'Wasted payer follow-up'];
const MORE = ['Clean claims on the first pass', 'Recovered and protected revenue', 'Faster, stronger appeals', 'Clarity for your whole team'];

const STATS = [
  { num: 'Minutes', label: 'From denial to a finished appeal' },
  { num: 'End-to-end', label: 'Fully automated, no busywork' },
  { num: '100%', label: 'Every decision explained' },
  { num: '24/7', label: 'Works around the clock' },
];

const ENTERPRISE_PLAN = {
  name: 'Enterprise',
  badge: 'For RCM companies, hospitals & health systems running 1,000+ cases / month',
  features: [
    'Custom volume pricing tailored to your monthly case count (1,000+)',
    'Direct EDI & clearinghouse integration (837 / 835 / 270 / 271)',
    'API access for your own systems and automations',
    'Dedicated onboarding, SLA, and audit-ready reporting',
    'Every module included - nothing locked behind tiers',
  ],
  cta: 'Request custom volume pricing',
  ctaHref: 'mailto:sales@cerebralmachines.ai?subject=Enterprise%20Volume%20Pricing%20(1%2C000%2B%20cases%2Fmonth)',
};

const PRICING_PLANS = [
  {
    name: 'Starter',
    badge: 'For independent practices getting started',
    amount: '$98',
    unit: '/ user / month',
    trial: 'Start with a 1-month free trial + 5 test cases',
    features: [
      '25 denial cases per user / month included',
      'Additional cases at $5 per case',
      'Every module included - nothing locked behind tiers',
      'Full automation, explainable results, audit trail',
    ],
  },
  {
    name: 'Growth',
    badge: 'For growing groups & multi-provider practices',
    amount: '$398',
    unit: '/ user / month',
    trial: 'Start with a 1-month free trial + 5 test cases',
    features: [
      '100 denial cases per user / month included',
      'Additional cases at $3.50 per case',
      'Every module included - nothing locked behind tiers',
      'Full automation, explainable results, audit trail',
    ],
  },
];

export default function HomePage() {
  useEffect(() => {
    document.title = 'RCMBoost - Recover more revenue · by CerebralMachines.ai';
  }, []);

  return (
    <div className="home">
      {/* Header */}
      <header className="home-header">
        <div className="home__wrap home-header__inner">
          <Link to="/" className="home-brand" aria-label="RCMBoost by CerebralMachines.ai">
            <img
              src={`${process.env.PUBLIC_URL || ''}/rcmboost-logo-light.png`}
              alt="RCMBoost — by CerebralMachines.ai"
              className="home-brand__img"
            />
          </Link>
          <nav className="home-nav">
            <a href="#how">How it works</a>
            <a href="#products">Products</a>
            <a href="#who">Who it&apos;s for</a>
            <a href="#pricing">Pricing</a>
            <Link to="/partner">Design Partners</Link>
          </nav>
          <div className="home-header__actions">
            <Link to="/login" className="home-link">Sign in</Link>
            <Link to="/register" className="home-btn home-btn--primary">Try it now</Link>
          </div>
        </div>
      </header>

      {/* Hero */}
      <section className="home-hero">
        <div className="home__wrap home-hero__inner">
          <div className="home-hero__copy">
            <span className="home-eyebrow"><span className="dot" /> Revenue intelligence for healthcare</span>
            <h1>Stop chasing denials.<br /><span className="grad">Keep the revenue you&apos;ve earned.</span></h1>
            <p className="home-hero__sub">
              Just upload your files or connect your systems. CerebralMachines reads the claim,
              finds the real reason it was denied, and either files the appeal for you or hands
              you a package ready to submit.
            </p>
            <div className="home-hero__cta">
              <Link to="/register" className="home-btn home-btn--primary home-btn--lg">Try it now <Icon.arrow /></Link>
              <Link to="/login" className="home-btn home-btn--ghost home-btn--lg">Sign in</Link>
            </div>
            <div className="home-hero__trust">
              <span className="home-trust-item"><Icon.check /> Fully automated, end to end</span>
              <span className="home-trust-item"><Icon.check /> No manual re-keying</span>
              <span className="home-trust-item"><Icon.check /> Every answer explained</span>
            </div>
          </div>

          <div className="home-hero__visual">
            <div className="home-mock">
              <div className="home-mock__bar">
                <span className="home-mock__dot" /><span className="home-mock__dot" /><span className="home-mock__dot" />
                <span className="home-mock__title">Triangulation workspace · DENIAL-2026-000217</span>
              </div>
              <div className="home-split">
                <div className="home-split__pane">
                  <div className="home-split__head">
                    <span className="home-split__edi">837</span>
                    <span className="home-split__panel">Claim submitted</span>
                  </div>
                  <div className="home-split__rows">
                    <div className="home-fieldrow"><span className="home-fieldrow__k">Patient</span><span className="home-fieldrow__v">R. Alvarez</span></div>
                    <div className="home-fieldrow"><span className="home-fieldrow__k">Date of service</span><span className="home-fieldrow__v">03/14/2026</span></div>
                    <div className="home-fieldrow"><span className="home-fieldrow__k">CPT / HCPCS</span><span className="home-fieldrow__v">99214</span></div>
                    <div className="home-fieldrow home-fieldrow--mismatch">
                      <span className="home-fieldrow__k">Billed</span><span className="home-fieldrow__v">$420.00</span>
                    </div>
                    <div className="home-fieldrow home-fieldrow--mismatch">
                      <span className="home-fieldrow__k">Units</span><span className="home-fieldrow__v">2</span>
                    </div>
                  </div>
                </div>
                <div className="home-split__seam"><span className="home-split__seamic"><Icon.link /></span></div>
                <div className="home-split__pane">
                  <div className="home-split__head home-split__head--payer">
                    <span className="home-split__edi home-split__edi--payer">835</span>
                    <span className="home-split__panel">Payer remittance</span>
                  </div>
                  <div className="home-split__rows">
                    <div className="home-fieldrow"><span className="home-fieldrow__k">Patient</span><span className="home-fieldrow__v">R. Alvarez</span></div>
                    <div className="home-fieldrow"><span className="home-fieldrow__k">Date of service</span><span className="home-fieldrow__v">03/14/2026</span></div>
                    <div className="home-fieldrow"><span className="home-fieldrow__k">CPT / HCPCS</span><span className="home-fieldrow__v">99214</span></div>
                    <div className="home-fieldrow home-fieldrow--mismatch">
                      <span className="home-fieldrow__k">Allowed</span><span className="home-fieldrow__v home-fieldrow__v--bad">$0.00</span>
                    </div>
                    <div className="home-fieldrow home-fieldrow--mismatch">
                      <span className="home-fieldrow__k">CARC</span><span className="home-fieldrow__v home-fieldrow__v--bad">CO-151</span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="home-evidence">
                <span className="home-evidence__ic"><Icon.book /></span>
                <div className="home-evidence__body">
                  <span className="home-evidence__label">Evidence panel · why this denied</span>
                  <span className="home-evidence__text">
                    Cross-referenced with the official <b>CARC/RARC master lists</b> &amp; <b>BCBS Provider Manual §4.2</b> — units exceed documented support.
                  </span>
                </div>
              </div>
              <div className="home-mock__foot">
                <span className="home-mock__footlabel">Recoverable this batch</span>
                <span className="home-mock__footval">$184,920</span>
              </div>
            </div>
            <div className="home-mock__badge">
              <span className="ic"><Icon.checkCircle /></span>
              <span className="tx"><b>Appeal generated</b><span>in under 2 minutes</span></span>
            </div>
          </div>
        </div>
      </section>

      {/* Stats strip */}
      <section className="home-strip">
        <div className="home__wrap home-strip__inner">
          {STATS.map((s) => (
            <div className="home-stat" key={s.label}>
              <div className="home-stat__num">{s.num}</div>
              <div className="home-stat__label">{s.label}</div>
            </div>
          ))}
        </div>
      </section>

      {/* Value points */}
      <section className="home-section">
        <div className="home__wrap">
          <div className="home-section__head">
            <p className="home-kicker">One platform</p>
            <h2>Everything for the whole claim journey</h2>
            <p className="home-section__lede">
              From cleaner claims to faster recoveries, it all works together - so your team spends
              less time digging and more time getting paid.
            </p>
          </div>
          <div className="home-values">
            {VALUES.map((v) => (
              <div className="home-value" key={v.title}>
                <div className="home-ic"><v.icon /></div>
                <h3>{v.title}</h3>
                <p>{v.text}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Fully automated */}
      <section className="home-section home-section--tint" id="how">
        <div className="home__wrap">
          <div className="home-section__head home-section__head--center">
            <p className="home-kicker">Fully automated</p>
            <h2>You bring the denial. We do the rest.</h2>
            <p className="home-section__lede">
              Upload your files or connect your systems once. From there it runs end to end - no
              step-by-step busywork. You choose how the finished appeal lands.
            </p>
          </div>

          <div className="home-auto__flow">
            <div className="home-flowstep">
              <div className="home-ic"><Icon.upload /></div>
              <h3>Upload your files</h3>
              <p>Drop in the denial and records - no manual re-keying.</p>
            </div>
            <div className="home-flowarrow"><Icon.arrow /></div>
            <div className="home-flowstep">
              <div className="home-ic"><Icon.plug /></div>
              <h3>…or stay integrated</h3>
              <p>Connect your systems once and new denials flow in on their own.</p>
            </div>
            <div className="home-flowarrow"><Icon.arrow /></div>
            <div className="home-flowstep">
              <div className="home-ic"><Icon.cpu /></div>
              <h3>It runs automatically</h3>
              <p>The full appeal is built end to end, with the reasoning shown.</p>
            </div>
          </div>

          <div className="home-outcomes">
            <div className="home-outcome home-outcome--dark">
              <span className="home-outcome__tag">Hands-off</span>
              <div className="home-outcome__icon"><Icon.send /></div>
              <h3>We file the appeal for you</h3>
              <p>A complete appeal is created and submitted to the payer electronically - run it fully automated, or hold each one for human review first. You decide.</p>
              <ul>{OUTCOME_FILE.map((x) => <li key={x}><Icon.check /> {x}</li>)}</ul>
            </div>
            <div className="home-outcome home-outcome--light">
              <span className="home-outcome__tag">Your control</span>
              <div className="home-outcome__icon"><Icon.download /></div>
              <h3>Or download a ready-to-submit package</h3>
              <p>Prefer to file it yourself? Get a complete, formatted appeal package - evidence and reasoning included - ready to submit through your own channels.</p>
              <ul>{OUTCOME_PACK.map((x) => <li key={x}><Icon.check /> {x}</li>)}</ul>
            </div>
          </div>
        </div>
      </section>

      {/* Wrong payer use case */}
      <section className="home-section">
        <div className="home__wrap">
          <div className="home-section__head home-section__head--center">
            <p className="home-kicker">Use case · wrong payer in disguise</p>
            <h2>An eligibility denial isn&apos;t an appeal. It&apos;s the wrong insurer.</h2>
            <p className="home-section__lede">
              You don&apos;t appeal an eligibility denial - you find the coverage that was actually
              active. The backend runs a real-time 270/271 check and re-routes the claim to the
              correct payer.
            </p>
          </div>

          <div className="home-usecase">
            <div className="home-mock home-mock--wide">
              <div className="home-mock__bar">
                <span className="home-mock__dot" /><span className="home-mock__dot" /><span className="home-mock__dot" />
                <span className="home-mock__title">Eligibility triangulation · DENIAL-2026-000219</span>
              </div>
              <div className="home-split">
                <div className="home-split__pane">
                  <div className="home-split__head">
                    <span className="home-split__edi">837</span>
                    <span className="home-split__panel">Submitted claim</span>
                  </div>
                  <div className="home-split__rows">
                    <div className="home-fieldrow"><span className="home-fieldrow__k">Patient</span><span className="home-fieldrow__v">M. Chen</span></div>
                    <div className="home-fieldrow"><span className="home-fieldrow__k">Date of service</span><span className="home-fieldrow__v">02/08/2026</span></div>
                    <div className="home-fieldrow home-fieldrow--mismatch">
                      <span className="home-fieldrow__k">Payer billed</span><span className="home-fieldrow__v home-fieldrow__v--bad">BCBS</span>
                    </div>
                    <div className="home-fieldrow home-fieldrow--mismatch">
                      <span className="home-fieldrow__k">CARC</span><span className="home-fieldrow__v home-fieldrow__v--bad">CO-27 · coverage terminated</span>
                    </div>
                  </div>
                </div>
                <div className="home-split__seam"><span className="home-split__seamic"><Icon.link /></span></div>
                <div className="home-split__pane">
                  <div className="home-split__head home-split__head--payer">
                    <span className="home-split__edi home-split__edi--payer">271</span>
                    <span className="home-split__panel">Real-time eligibility log</span>
                  </div>
                  <div className="home-split__rows">
                    <div className="home-elig home-elig--bad">
                      <span className="home-elig__dot" />
                      <div className="home-elig__main">
                        <span className="home-elig__name">BCBS PPO</span>
                        <span className="home-elig__status">Policy terminated 12/31/2025 - not active on DOS</span>
                      </div>
                    </div>
                    <div className="home-elig home-elig--good">
                      <span className="home-elig__dot home-elig__dot--ok" />
                      <div className="home-elig__main">
                        <span className="home-elig__name">UnitedHealthcare Choice Plus</span>
                        <span className="home-elig__status">Active on 02/08/2026 - eligible for this service</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="home-mock__action">
                <button type="button" className="home-btn home-btn--reroute home-btn--lg">
                  <Icon.send /> Re-route &amp; submit corrected claim to UHC
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Suite */}
      <section className="home-section" id="products">
        <div className="home__wrap">
          <div className="home-section__head home-section__head--center">
            <p className="home-kicker">The suite</p>
            <h2>Use the whole platform, or just one part</h2>
            <p className="home-section__lede">Each product earns its keep on its own - and they get stronger together. All in plain English.</p>
          </div>
          <div className="home-cards">
            {SUITE.map((c) => (
              <Link className="home-card home-card--link" to={c.to} key={c.name}>
                <div className="home-ic"><c.icon /></div>
                <div className="home-card__name">{c.name}</div>
                <p className="home-card__desc">{c.desc}</p>
                <span className="home-card__cta">Open {c.name} <Icon.arrow /></span>
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* Audiences */}
      <section className="home-section home-section--tint" id="who">
        <div className="home__wrap">
          <div className="home-section__head home-section__head--center">
            <p className="home-kicker">Who it&apos;s for</p>
            <h2>Built for your team</h2>
            <p className="home-section__lede">Whatever your role in the revenue cycle, it meets you where you are.</p>
          </div>
          <div className="home-audiences">
            {AUDIENCES.map((a) => (
              <div className="home-aud" key={a.title}>
                <div className="home-ic"><a.icon /></div>
                <h3>{a.title}</h3>
                <ul>{a.points.map((p) => <li key={p}><Icon.check /> {p}</li>)}</ul>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Why different */}
      <section className="home-section">
        <div className="home__wrap">
          <div className="home-section__head home-section__head--center">
            <p className="home-kicker">Why it&apos;s different</p>
            <h2>Accurate, explainable, and preventive</h2>
            <p className="home-section__lede">Built to earn trust - and to stop problems instead of just reacting to them.</p>
          </div>
          <div className="home-why">
            {WHY.map((w) => (
              <div className="home-why__item" key={w.title}>
                <div className="home-ic"><w.icon /></div>
                <h3>{w.title}</h3>
                <p>{w.text}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Pricing */}
      <section className="home-section" id="pricing">
        <div className="home__wrap">
          <div className="home-section__head home-section__head--center">
            <p className="home-kicker">Pricing</p>
            <h2>Plans that scale with you</h2>
            <p className="home-section__lede">
              Start per user with every module included, or go enterprise with full EDI and API
              integration and volume-based pricing. Every plan ships with the complete platform.
            </p>
          </div>
          <div className="home-pricing">
            <div className="home-pricing__grid">
              {PRICING_PLANS.map((plan) => (
                <div className="home-price-card home-price-card--sm" key={plan.name}>
                  <span className="home-price-card__badge">{plan.badge}</span>
                  <h3 className="home-price-card__name">{plan.name}</h3>
                  <div className="home-price-card__price">
                    <span className="home-price-card__amount">{plan.amount}</span>
                    <span className="home-price-card__unit">{plan.unit}</span>
                  </div>
                  <div className="home-price-card__trial">
                    <Icon.spark /> {plan.trial}
                  </div>
                  <ul className="home-price-card__features">
                    {plan.features.map((f) => <li key={f}><Icon.check /> {f}</li>)}
                  </ul>
                  <Link to="/register" className="home-btn home-btn--ghost home-btn--lg home-price-card__cta">
                    Start your free trial <Icon.arrow />
                  </Link>
                </div>
              ))}
              <div className="home-price-card home-price-card--enterprise">
                <span className="home-price-card__badge home-price-card__badge--enterprise"><Icon.building /> {ENTERPRISE_PLAN.badge}</span>
                <h3 className="home-price-card__name">{ENTERPRISE_PLAN.name}</h3>
                <div className="home-price-card__price">
                  <span className="home-price-card__amount home-price-card__amount--custom">Custom volume pricing</span>
                </div>
                <div className="home-price-card__trial home-price-card__trial--enterprise">
                  <Icon.building /> Built for high-volume RCM, hospitals & health systems
                </div>
                <ul className="home-price-card__features">
                  {ENTERPRISE_PLAN.features.map((f) => <li key={f}><Icon.check /> {f}</li>)}
                </ul>
                <a href={ENTERPRISE_PLAN.ctaHref} className="home-btn home-btn--primary home-btn--lg home-price-card__cta">
                  {ENTERPRISE_PLAN.cta} <Icon.arrow />
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Expectations */}
      <section className="home-section home-section--tint">
        <div className="home__wrap">
          <div className="home-section__head home-section__head--center">
            <p className="home-kicker">What you can expect</p>
            <h2>Less of the grind. More of the revenue.</h2>
          </div>
          <div className="home-expect">
            <div className="home-expect__col home-expect__col--less">
              <h3>Less <span className="tag">drag on your team</span></h3>
              <ul>{LESS.map((x) => <li key={x}><Icon.minus /> {x}</li>)}</ul>
            </div>
            <div className="home-expect__col home-expect__col--more">
              <h3>More <span className="tag">in your bottom line</span></h3>
              <ul>{MORE.map((x) => <li key={x}><Icon.plus /> {x}</li>)}</ul>
            </div>
          </div>
        </div>
      </section>

      {/* Closing CTA */}
      <section className="home-cta">
        <div className="home-cta__band">
          <div className="home-cta__inner">
            <div className="home-cta__content">
              <h2>Ready to recover more revenue?</h2>
              <p>Turn denial management into revenue intelligence - starting today.</p>
              <Link to="/register" className="home-btn home-btn--light home-btn--lg">Try it now <Icon.arrow /></Link>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="home-footer">
        <div className="home__wrap home-footer__inner">
          <div className="home-footer__brand">
            <img
              src={`${process.env.PUBLIC_URL || ''}/rcmboost-logo-light.png`}
              alt="RCMBoost — by CerebralMachines.ai"
              className="home-brand__img home-brand__img--sm"
            />
            <span className="home-footer__copy">
              © {new Date().getFullYear()} CerebralMachines, Inc. All rights reserved.
            </span>
          </div>
          <div className="home-footer__links">
            <Link to="/terms">Terms of Use</Link>
            <Link to="/login">Sign in</Link>
            <Link to="/register">Try it now</Link>
          </div>
        </div>
      </footer>
    </div>
  );
}
